import React from "react";

function Header() {
  return (
    <header>
      <h1>Header</h1>
    </header>
  );
}

export default Header;
